import { RoundButton } from 'component/Button/RoundButton'
import { Typo } from 'component/Typo'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { opt } from 'store/opt'
import css from './DashedButton.module.scss'

type Props = {
  children: string
  onClick: () => void
}

export const DashedButton = observer(({ children, onClick }: Props) => {
  if (opt.stand2) return <RoundButton className={css.stand} onClick={onClick}>
    <Icon size={24} name="info" />
    <Typo size={16} line={24} medium upper>
      {children}
    </Typo>
  </RoundButton>

  return <RoundButton className={css.dashed} onClick={onClick}>
    <Icon size={16} name="info" fill />
    <Typo size={13} line={16}>
      {children}
    </Typo>
  </RoundButton>
})
